import { render, staticRenderFns } from "./removedJobs.vue?vue&type=template&id=28346924&"
import script from "./removedJobs.vue?vue&type=script&lang=js&"
export * from "./removedJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports